// eslint-disable-next-line no-shadow
export enum PaymentSourceEnum {
  IYZICO = 0,
  IYZICO2 = 1,
  NKOLAY = 10,
  NKOLAY_2 = 11,
  NKOLAY_3 = 12,
}

export const PaymentSourceEnumLabel = new Map<number, string>([
  [PaymentSourceEnum.IYZICO, 'IYZICO'],
  [PaymentSourceEnum.IYZICO2, 'IYZICO2'],
  [PaymentSourceEnum.NKOLAY, 'NKolay'],
  [PaymentSourceEnum.NKOLAY_2, 'NKolay 2'],
  [PaymentSourceEnum.NKOLAY_3, 'NKolay 3'],
]);

